import { GameMessageBarProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameMessageBarProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { Point } from "pixi.js";
export class MessageBarLandscapeProperties extends GameMessageBarProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.position = new Point(973, 0);
        this.backgroundProperties.anchor = new Point(0.5, 0);
        this.clockProperties.position = new Point(2336, -5);
        this.clockProperties.horizontalAlign = ControlConstants.RIGHT;
        this.gameIdProperties.position = new Point(0, -5);
        this.gameIdProperties.size = new Point(320, 57);
        this.gameIdProperties.horizontalAlign = ControlConstants.LEFT;
        this.messageFieldProperties.position = new Point(973, -5);
        this.fieldOffset = -66;
    }
}
